module.exports = __webpack_public_path__ + "static/media/logo-plus.7f279d55.svg";